import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from './store';
import { loadMenuData, loadOnboardingScreens, loadRuntimeApiConfig } from './store/orderSlice';
import WelcomeScreen from './components/screens/WelcomeScreen';
import LoyaltyScreen from './components/screens/LoyaltyScreen';
import DiningSelectionScreen from './components/screens/DiningSelectionScreen';
import MenuScreen from './components/screens/MenuScreen';
import ItemDetailScreen from './components/screens/ItemDetailScreen';
import CartScreen from './components/screens/CartScreen';
import PaymentScreen from './components/screens/PaymentScreen';
import PayHereScreen from './components/screens/PayHereScreen';
import PayAtCounterScreen from './components/screens/PayAtCounterScreen';
import SuccessScreen from './components/screens/SuccessScreen';
import './App.css';

function App() {
  const dispatch = useDispatch<AppDispatch>();
  const { currentScreen, isLoading, error, menuCategories, menuItems } = useSelector((state: RootState) => state.order);

  useEffect(() => {
    // Load runtime CMS settings first, then fetch data.
    const init = async () => {
      await dispatch(loadRuntimeApiConfig());
      dispatch(loadMenuData());
      dispatch(loadOnboardingScreens());
    };

    init();
  }, [dispatch]);

  // Show loading screen while menu data is being fetched
  if (isLoading && currentScreen === 'welcome') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex flex-col items-center justify-center p-8">
        <div className="text-center">
          <div className="mb-8">
          </div>
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
        </div>
      </div>
    );
  }

  // Show error screen only if loading is complete, there's an error, AND no menu data is available
  if (!isLoading && error && menuCategories.length === 0 && menuItems.length === 0 && currentScreen === 'welcome') {
    console.log('Error:', error);
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex flex-col items-center justify-center p-8">
        <div className="text-center">
          <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-200 max-w-md">
            <div className="text-6xl mb-6 text-secondary">⚠️</div>
            <h1 className="text-3xl font-bold mb-4 text-gray-800">Oops! Something went wrong</h1>
            <p className="text-lg text-gray-600 mb-8">{error}</p>
            <button 
              onClick={() => dispatch(loadMenuData())}
              className="bg-primary text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary-hover transition-colors shadow-lg"
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    );
  }

  const renderScreen = () => {
    switch (currentScreen) {
      case 'welcome':
        return <WelcomeScreen />;
      case 'loyalty':
        return <LoyaltyScreen />;
      case 'dining-selection':
        return <DiningSelectionScreen />;
      case 'menu':
        return <MenuScreen />;
      case 'item-detail':
        return <ItemDetailScreen />;
      case 'cart':
        return <CartScreen />;
      case 'payment':
        return <PaymentScreen />;
      case 'pay-here':
        return <PayHereScreen />;
      case 'pay-at-counter':
        return <PayAtCounterScreen />;
      case 'success':
        return <SuccessScreen />;
      default:
        return <WelcomeScreen />;
    }
  };

  return (
    <div className="App relative">
      {renderScreen()}
    </div>
  );
}

export default App;
